var _rect, _rect2, _rect3, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRechargeBill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 26,
    width: 224,
    height: 400,
    fill: "#FF9500"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 441,
    width: 145,
    height: 41,
    fill: "#F0FFF1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 38,
    width: 174,
    height: 37,
    fill: "#FF9500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M376.737 130.827C381.524 130.827 385.413 126.893 385.413 122.151V87.3955C385.413 85.0246 384.5 82.8556 382.891 81.2414C381.227 79.6272 379.057 78.7192 376.737 78.7192C376.48 78.7192 376.228 78.7192 375.98 78.7696V56.6753C375.98 38.566 361.301 23.8365 343.192 23.8365H213.955C214.006 23.6347 214.006 23.3825 214.006 23.1807C214.006 18.0859 209.87 14 204.825 14H166.791C164.369 14 162.049 14.9584 160.334 16.6735C158.568 18.439 157.61 20.709 157.61 23.1807C157.61 23.3825 157.66 23.6347 157.66 23.8365H153.675C135.566 23.8365 120.837 38.566 120.837 56.6753V78.7192H120.181C115.086 78.7192 111 82.8051 111 87.8999V125.884C111 128.356 111.958 130.676 113.674 132.391C115.389 134.106 117.709 135.065 120.181 135.065H120.837V458.156C120.837 476.27 135.566 491 153.675 491H343.192C361.301 491 375.98 476.27 375.98 458.156V188.434C376.233 188.485 376.485 188.485 376.737 188.485C381.524 188.485 385.413 184.6 385.413 179.808V145.053C385.413 142.732 384.5 140.563 382.891 138.949C381.227 137.284 379.057 136.376 376.737 136.376C376.48 136.376 376.228 136.376 375.98 136.427V130.777C376.233 130.777 376.485 130.827 376.737 130.827ZM272.672 475.055C272.672 476.871 271.209 478.329 269.398 478.329H231.818C230.002 478.329 228.539 476.871 228.539 475.055V449.631C228.539 447.815 230.002 446.352 231.818 446.352H269.398C271.209 446.352 272.672 447.815 272.672 449.631V475.055ZM334.465 53.0434C334.465 58.4913 330.082 62.8799 324.634 62.8799C319.236 62.8799 314.848 58.4913 314.848 53.0434C314.848 47.6459 319.236 43.2573 324.634 43.2573C330.077 43.2573 334.465 47.6459 334.465 53.0434ZM221.926 43.2573H274.942C280.339 43.2573 284.728 47.6459 284.728 53.0434C284.728 58.4913 280.339 62.8799 274.942 62.8799H221.926C216.478 62.8799 212.089 58.4913 212.089 53.0434C212.089 47.6459 216.478 43.2573 221.926 43.2573ZM352.625 81.2414V433.59H144.192V81.2414H352.625Z",
    fill: "#F0FFF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.805 304.28L195.339 275.226",
    stroke: "#F0FFF1",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.727 304.208L304.591 212.824",
    stroke: "#F0FFF1",
    strokeWidth: 25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRechargeBill);
export default __webpack_public_path__ + "static/media/recharge_bill.8bc1dea81428e7a4196182dbdff2587d.svg";
export { ForwardRef as ReactComponent };